import { render, staticRenderFns } from "./FarmerApplication.vue?vue&type=template&id=876514c2&scoped=true"
import script from "./FarmerApplication.vue?vue&type=script&lang=js"
export * from "./FarmerApplication.vue?vue&type=script&lang=js"
import style0 from "./FarmerApplication.vue?vue&type=style&index=0&id=876514c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876514c2",
  null
  
)

export default component.exports